<template>
  <div class="m-3">
    <button
      @click="selectImages()"
      :disabled="disabled && loading !== 0"
      :class="{
        'border border-red-500' : error,
        'hover:bg-blue-500': loading === 0
      }"
      class="flex items-center justify-center w-40 h-32 border outline-none focus:outline-none group"
    >
      <font-awesome-icon
        v-if="loading === 0"
        icon="plus"
        class="text-3xl"
      />
      <div v-else class="w-7 h-7 animate-spin text-content">
        <loading />
    </div>
    </button>
    <input
      @change="filesChange"
      class="hidden"
      id="images"
      type="file"
      accept="image/*"
      multiple
    />
  </div>
</template>

<script>
import imageCompression from 'browser-image-compression';
import Loading from 'vue-material-design-icons/Loading.vue';

export default {
  name: 'select-images',
  components: {
    Loading,
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      required: true,
    },
    error: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      localImages: this.images,
      loading: 0,
    };
  },
  methods: {
    async filesChange(event) {
      const files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      Object.values(files).reduce(async (memo, f) => {
        await memo;
        let file = f;
        const maxMB = 2;
        if (file.size > 1048576 * maxMB) {
          this.loading += 1;
          file = await imageCompression(file, {
            maxSizeMB: maxMB,
            onProgress: console.log,
          });
          this.loading -= 1;
        }
        const reader = new FileReader();
        // eslint-disable-next-line func-names
        reader.onload = (e) => {
          this.localImages.push(
            // TODO Test to make sure each new item has the following properties!!!
            {
              id: this.imageIdGenerator(),
              extension: 'png',
              base64: e.target.result,
              deleted: false,
              new: true,
            },
          );
        };
        reader.readAsDataURL(file);
      }, undefined);
      // Object.values(files).forEach(async (f) => {
      // });
      // removes the files from the input object
      document.querySelector('#images').value = null;
    },
    selectImages() {
      document.querySelector('#images').click();
    },
    imageIdGenerator() {
      let newId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      const idExists = this.localImages.filter((img) => img.id == newId) > 0;
      if (idExists) newId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
      return newId;
    },
  },
  watch: {
    localImages(newVal) {
      this.$emit('update:images', newVal);
    },
    images: {
      handler(newImages) {
        this.localImages = newImages;
      },
    },
  },
};
</script>
